// Excel Template Mock Data
export const mockExcelTemplates = [
  {
    custom_setting_id: "0",
    setting_name: "기본 양식",
    created_at: "2023-10-01T12:00:00Z",
    updated_at: "2023-10-02T12:00:00Z",
    is_preset: true,
    column_settings: [
      "supplier_name", "supplier_code", "settlement_no", "order_id", 
      "order_item_code", "product_name", "option_name", "quantity", 
      "sale_price", "settlement_amount", "commission_amount", 
      "shipping_fee", "settlement_schedule_at", "settlement_completion_at"
    ]
  },
  {
    custom_setting_id: 1,
    setting_name: "커스텀 simple 양식",
    created_at: "2023-10-01T12:00:00Z",
    updated_at: "2023-10-02T12:00:00Z",
    is_preset: false,
    column_settings: [
      "order_id", "product_name", "quantity", "sale_price", "settlement_amount"
    ]
  },
  {
    custom_setting_id: 2,
    setting_name: "커스텀 별 양식",
    created_at: "2023-10-03T12:00:00Z",
    updated_at: "2023-10-04T12:00:00Z",
    is_preset: false,
    column_settings: [
      "supplier_name", "order_id", "product_name", "quantity", 
      "sale_price", "commission_amount", "settlement_schedule_at"
    ]
  },
  {
    custom_setting_id: 3,
    setting_name: "커스텀 정산 양식",
    created_at: "2023-10-05T12:00:00Z",
    updated_at: "2023-10-05T12:00:00Z",
    is_preset: false,
    column_settings: [
      "supplier_name", "supplier_code", "settlement_no", "",
      "order_id",
      "order_item_code", "exchange_no", "return_no", "order_status",
      "settlement_category", "",
      "product_name", "option_name", "quantity",
      "sale_price", "settlement_amount", "additional_discount_amount",
      "coupon_discount_price", "add_item_discount_price", "shipping_fee",
      "regional_surcharge_amount", "individual_shipping_fee", 
      "commission_amount", "commission_percent", "penalty_amount",
      "deduction_amount", "refund_amount", "settlement_defer_amount",
      "settlement_schedule_at", "settlement_completion_at"
    ]
  }
];


// 동적 데이터 생성 함수들
export function generateExcelTemplate(id, name, isPreset = false) {
  return {
    custom_setting_id: id,
    setting_name: name,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    is_preset: isPreset,
    column_settings: isPreset 
      ? ["order_id", "product_name", "quantity", "sale_price", "settlement_amount"]
      : ["order_id", "product_name", "quantity", "sale_price"]
  };
}

export function getTemplatesByType(type) {
  switch (type) {
    case 'preset':
      return mockExcelTemplates.filter(template => template.is_preset);
    case 'custom':
      return mockExcelTemplates.filter(template => !template.is_preset);
    case 'all':
    default:
      return mockExcelTemplates;
  }
}

export function getTemplateById(id) {
  return mockExcelTemplates.find(template => 
    template.custom_setting_id === id || template.custom_setting_id === String(id)
  );
}

export function getPresetByName(name) {
  return mockExcelTemplates.find(template => 
    template.is_preset && template.setting_name === name
  ) || null;
}

// 페이지네이션 시뮬레이션
export function paginateTemplates(templates, offset = 0, limit = 10) {
  const startIndex = offset;
  const endIndex = startIndex + limit;
  
  return {
    total_count: templates.length,
    list: templates.slice(startIndex, endIndex)
  };
}

// Mock 데이터 추가/수정/삭제 함수들 (실제 배열 조작)
export function addMockTemplate(template) {
  const newId = Math.max(...mockExcelTemplates.map(t => 
    typeof t.custom_setting_id === 'number' ? t.custom_setting_id : 0
  )) + 1;
  
  const newTemplate = {
    ...template,
    custom_setting_id: newId,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    is_preset: false
  };
  
  mockExcelTemplates.push(newTemplate);
  return newTemplate;
}

export function updateMockTemplate(id, updates) {
  const index = mockExcelTemplates.findIndex(template => 
    template.custom_setting_id === id || template.custom_setting_id === String(id)
  );
  
  if (index !== -1) {
    mockExcelTemplates[index] = {
      ...mockExcelTemplates[index],
      ...updates,
      updated_at: new Date().toISOString()
    };
    return mockExcelTemplates[index];
  }
  return null;
}

export function deleteMockTemplate(id) {
  const index = mockExcelTemplates.findIndex(template => 
    template.custom_setting_id === id || template.custom_setting_id === String(id)
  );
  
  if (index !== -1) {
    return mockExcelTemplates.splice(index, 1)[0];
  }
  return null;
}

export function bulkDeleteMockTemplates(ids) {
  const deletedTemplates = [];
  ids.forEach(id => {
    const deleted = deleteMockTemplate(id);
    if (deleted) {
      deletedTemplates.push(deleted);
    }
  });
  return deletedTemplates;
}
